import { formatNumber, toFixed } from "@/lib/utils";
import { DSContractState } from "@myth-finance/dualstake-ts-sdk";
import { cx } from "class-variance-authority";
import { ChevronDown, ChevronRight } from "lucide-react";
import { AccountLink } from "@/components/links";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from "@/components/ui/collapsible";

export function FeesRolesBareCard({
  className,
  cState,
}: {
  className?: string;
  cState: DSContractState;
}) {
  return (
    <Collapsible
      className={cx(
        `group flex-col text-muted-foreground/90 flex min-w-[300px] w-full max-w-[350px] p-0 mt-0 gap-1 items-stretch data-[state=open]:mb-4`,
        className
      )}
    >
      <div>
        <CollapsibleTrigger
          asChild
          className="flex items-center gap-0 text-muted-foreground group-data-[state=open]:text-foreground"
        >
          <div className="cursor-pointer">
            <Button variant="ghost" size="sm">
              <ChevronDown className="h-4 w-4 group-data-[state=closed]:hidden" />
              <ChevronRight className="h-4 w-4 group-data-[state=open]:hidden" />
              <span className="sr-only">Toggle</span>
            </Button>
            <span>Fees & Roles Info</span>
          </div>
        </CollapsibleTrigger>
      </div>
      <CollapsibleContent className="space-y-2 pt-2 px-4">
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div>Mint fee rate</div>
            <div>{toFixed(0, 2)}%</div>
          </div>

          <div className="flex justify-between items-center">
            <div>Redeem fee rate</div>
            <div>{toFixed(0, 2)}%</div>
          </div>

          <div className="flex justify-between items-center">
            <div>Rewards fee rate</div>
            <div>
              {toFixed(
                Number(cState.noderunnerFeeBps + cState.platformFeeBps) / 100,
                2
              )}
              %
            </div>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div>Node runner</div>
            <AccountLink short={true} address={cState.noderunnerAddr} />
          </div>

          <div className="flex justify-between items-center">
            <div>Node runner fees</div>
            {formatNumber(cState.noderunnerFees, 6, 2)} ALGO
          </div>

          <div className="flex justify-between items-center">
            <div>Node runner fee rate</div>
            <div>{toFixed(Number(cState.noderunnerFeeBps) / 100, 2)}%</div>
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div>Admin</div>
            <AccountLink short={true} address={cState.adminAddr} />
          </div>

          <div className="flex justify-between items-center">
            <div>Fee admin</div>
            <AccountLink short={true} address={cState.feeAdminAddr} />
          </div>

          <div className="flex justify-between items-center">
            <div>Platform fees</div>
            {formatNumber(cState.platformFees, 6, 2)} ALGO
          </div>

          <div className="flex justify-between items-center">
            <div>Platform fee rate</div>
            <div>{toFixed(Number(cState.platformFeeBps) / 100, 2)}%</div>
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
